import CaseDiffToolContainer from './CaseDiffToolContainer';

export default CaseDiffToolContainer;
